import ReactDOM from 'react-dom/client';
import { Navigate, Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

import OktaAuth, { OktaAuthOptions } from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import { _config } from './config';
import { Login } from './pages/authentication/Login';
import RequireAuth from './pages/authentication/RequireAuth';
import Home from './pages/Home';
import Records from './pages/Records';
import { UserManagement } from './pages/UserManagement';
import reportWebVitals from './reportWebVitals';

console.log(window.location.origin);

export const oktaConfig: OktaAuthOptions = {
  clientId: _config.OktaClientId,
  redirectUri: `${window.location.origin}/login/callback`,
  issuer: _config.OktaIssuer,
  scopes: ['openid', 'profile', 'email'],

  responseType: 'code',
  pkce: true,

  cookies: {
    secure: true,
  },
  postLogoutRedirectUri: window.location.origin + '/login',
  tokenManager: {
    secure: true,
    storage: 'localStorage',
    autoRemove: true,
    autoRenew: true,
  },
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/login" /> },
      { path: 'login', element: <Login /> },
      {
        element: (
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        ),
        children: [
          { path: 'Records', element: <Records /> },
          { path: 'UserManagement', element: <UserManagement /> },
          { path: 'home', element: <Home /> },
        ],
      },
      { path: 'login/callback', element: <LoginCallback /> },
    ],
  },
]);

export const oktaAuth = new OktaAuth(oktaConfig);

// Required function for Okta Security

const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri?: string) => {
  const protectedRoutes = ['/Records', '/UserManagement'];
  if (originalUri && protectedRoutes.some((route) => originalUri.startsWith(route))) {
    window.location.replace(originalUri);
  } else {
    window.location.replace('/home');
  }
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
    <RouterProvider router={router} />
  </Security>,
);

//ReactDOM.createRoot(document.getElementById('root')!).render(<RouterProvider router={router} />);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
